import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/products/_layout")({
  component: ProductsLayout,
});

function ProductsLayout() {
  const location = useLocation();
  const pathname = location.pathname;

  const isFormPage =
    pathname.includes("/products/new") || pathname.includes("/edit");

  return (
<RouteGuardPermissions
      permissions={[{ module: "products", actions: ["read"] }]}>
      
    <RouteGuard module="products">
      <div className="space-y-4">
        <Outlet />
      </div>
    </RouteGuard>
  
    </RouteGuardPermissions>
  );
}
